module.exports = __webpack_public_path__ + "static/media/logo.67ae4aa0.webp";